var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scroll-box", {
    attrs: {
      data: _vm.data,
      loading: _vm.loading,
      total: _vm.total,
      showMore: _vm.showMore,
      emptyText: "暂不支持获取语音通话内容"
    },
    on: {
      loadMore: function($event) {
        return _vm.$emit("loadMore")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "left",
        fn: function(scope) {
          return [
            _c("audio-record", {
              attrs: { src: scope.row.audioUrl, type: "left" }
            })
          ]
        }
      },
      {
        key: "right",
        fn: function(scope) {
          return [
            _c("audio-record", {
              attrs: { src: scope.row.audioUrl, type: "right" }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }